export default {"src":"/_next/static/media/NKE.2d403a7f.svg","height":18,"width":18};